import { defineComponent } from 'vue';
import { createTeleport } from '#layers/base/public';
import { providePageBreadcrumbItems } from '#layers/ui/composables/page-breadcrumb-context';

const [provideHeaderActions, RenderPageHeaderActions, TeleportPageHeaderActions] = createTeleport('PageHeaderActions');
const [provideActions, RenderPageActions, TeleportPageActions] = createTeleport('PageActions');

export {
	RenderPageActions,
	RenderPageHeaderActions,
	TeleportPageActions,
	TeleportPageHeaderActions,
};

export const PageSlotProvider = defineComponent({
	setup(_, { slots }) {
		provideHeaderActions();
		provideActions();
		providePageBreadcrumbItems();

		return () => slots.default?.();
	},
});
